import { FC } from 'react'

import { createPortal } from 'react-dom'

import { PortalProps } from './types'

export const Portal: FC<PortalProps> = ({ componentName, children }) => {
  const elPortal = document.getElementById(`${componentName}-portal`) as HTMLElement

  return createPortal(children, elPortal)
}
